import { createFileRoute } from "@tanstack/react-router";
import { QueueGroupForm } from "./-components/queue-group-form";
import { usePermissionRedirect } from "@/hooks/use-permission-redirect";

export const Route = createFileRoute("/_dashboard/queue-groups/new-group")({
  component: RouteComponent,
  loader: async ({ context }) => ({
    crumb: "New group",
    user: (context as any).user,
  }),
});

function RouteComponent() {
  const { user } = Route.useLoaderData();
  usePermissionRedirect({
    user,
    permission: "QUEUE_GROUP",
    checkType: "write",
    toastMessage: "You don't have permission to create queue groups.",
    redirectTo: "/queue-groups",
  });
  return <QueueGroupForm queueGroup={null} isEdit={false} />;
}
